// extracted by mini-css-extract-plugin
export default {"wrapper":"menu_wrapper__5K2FN","close":"menu_close__9vsuC","inside":"menu_inside__nTLNk"};